// Mock data for BEANZ NFTs
export const beanzNfts = [
  {
    id: 19949,
    name: 'BEANZ #19949',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19949.png',
    price: '0.89 ETH'
  },
  {
    id: 19948,
    name: 'BEANZ #19948',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19948.png',
    price: '0.91 ETH'
  },
  {
    id: 19947,
    name: 'BEANZ #19947',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19947.png',
    price: '0.93 ETH'
  },
  {
    id: 19946,
    name: 'BEANZ #19946',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19946.png',
    price: '0.95 ETH'
  },
    
  {
    id: 19945,
    name: 'BEANZ #19945',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19945.png',
    price: '0.89 ETH'
  },
  {
    id: 19944,
    name: 'BEANZ #19944',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19944.png',
    price: '0.91 ETH'
  },
  {
    id: 19943,
    name: 'BEANZ #19943',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19943.png',
    price: '0.92 ETH'
  },
  {
    id: 19942,
    name: 'BEANZ #19942',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19942.png',
    price: '0.88 ETH'
  },
  {
    id: 19941,
    name: 'BEANZ #19941',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19941.png',
    price: '0.90 ETH'
  },
  {
    id: 19940,
    name: 'BEANZ #19940',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19940.png',
    price: '0.93 ETH'
  },
  {
    id: 19939,
    name: 'BEANZ #19939',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19939.png',
    price: '0.89 ETH'
  },
  {
    id: 19938,
    name: 'BEANZ #19938',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19938.png',
    price: '0.91 ETH'
  },
  {
    id: 19937,
    name: 'BEANZ #19937',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19937.png',
    price: '0.90 ETH'
  },
  {
    id: 19936,
    name: 'BEANZ #19936',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19936.png',
    price: '0.92 ETH'
  },
  {
    id: 19935,
    name: 'BEANZ #19935',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19935.png',
    price: '0.88 ETH'
  },
  {
    id: 19934,
    name: 'BEANZ #19934',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19934.png',
    price: '0.89 ETH'
  },
  {
    id: 19933,
    name: 'BEANZ #19933',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19933.png',
    price: '0.91 ETH'
  },
  {
    id: 19932,
    name: 'BEANZ #19932',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19932.png',
    price: '0.90 ETH'
  },
  {
    id: 19931,
    name: 'BEANZ #19931',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19931.png',
    price: '0.92 ETH'
  },
  {
    id: 19930,
    name: 'BEANZ #19930',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19930.png',
    price: '0.88 ETH'
  },
  {
    id: 19929,
    name: 'BEANZ #19929',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19929.png',
    price: '0.89 ETH'
  },
  {
    id: 19928,
    name: 'BEANZ #19928',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19928.png',
    price: '0.91 ETH'
  },
  {
    id: 19927,
    name: 'BEANZ #19927',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19927.png',
    price: '0.90 ETH'
  },
  {
    id: 19926,
    name: 'BEANZ #19926',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19926.png',
    price: '0.92 ETH'
  },
  {
    id: 19925,
    name: 'BEANZ #19925',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19925.png',
    price: '0.88 ETH'
  },
  {
    id: 19924,
    name: 'BEANZ #19924',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19924.png',
    price: '0.89 ETH'
  },
  {
    id: 19923,
    name: 'BEANZ #19923',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19923.png',
    price: '0.91 ETH'
  },
  {
    id: 19922,
    name: 'BEANZ #19922',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19922.png',
    price: '0.90 ETH'
  },
  {
    id: 19921,
    name: 'BEANZ #19921',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19921.png',
    price: '0.92 ETH'
  },
  {
    id: 19920,
    name: 'BEANZ #19920',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19920.png',
    price: '0.88 ETH'
  },
  {
    id: 19919,
    name: 'BEANZ #19919',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19919.png',
    price: '0.89 ETH'
  },
  {
    id: 19918,
    name: 'BEANZ #19918',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19918.png',
    price: '0.91 ETH'
  },
  {
    id: 19917,
    name: 'BEANZ #19917',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19917.png',
    price: '0.90 ETH'
  },
  {
    id: 19916,
    name: 'BEANZ #19916',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19916.png',
    price: '0.92 ETH'
  },
  {
    id: 19915,
    name: 'BEANZ #19915',
    image: 'https://ipfs.io/ipfs/QmTRuWHr7bpqscUWFmhXndzf5AdQqkekhqwgbyJCqKMHrL/19915.png',
    price: '0.88 ETH'
  }
 
    
];
